// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UserProfileForm_title__VcIo4 {
  font-size: 1rem;
}

@media screen and (min-width: 48em) {
  .UserProfileForm_title__VcIo4 {
    font-size: 1.125rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/settings/userProfile/UserProfileForm.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;;AAEA;EACE;IACE,mBAAA;EACF;AACF","sourcesContent":[".title {\r\n  font-size: 1rem;\r\n}\r\n\r\n@media screen and (min-width: 48em) {\r\n  .title {\r\n    font-size: 1.125rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `UserProfileForm_title__VcIo4`
};
export default ___CSS_LOADER_EXPORT___;
